import { FunctionComponent } from 'react';


const EmailErrorMP: FunctionComponent = () => (
  <svg className="error-svg" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.5" y="1.5" width="61" height="61" rx="30.5" fill="white" />
    <rect x="1.5" y="1.5" width="61" height="61" rx="30.5" stroke="#F23D4F" strokeWidth="3" />
    <path d="M40 52C40 45.3726 45.3726 40 52 40C58.6274 40 64 45.3726 64 52C64 58.6274 58.6274 64 52 64C45.3726 64 40 58.6274 40 52Z" fill="#F23D4F" />
    <path d="M53.455 45.8184H50.5459L50.9095 53.8184H53.0914L53.455 45.8184Z" fill="white" />
    <path d="M52.0004 55.2729C52.8038 55.2729 53.455 55.9241 53.455 56.7274C53.455 57.5308 52.8038 58.182 52.0004 58.182C51.1971 58.182 50.5459 57.5308 50.5459 56.7274C50.5459 55.9241 51.1971 55.2729 52.0004 55.2729Z" fill="white" />
    <path fillRule="evenodd" clipRule="evenodd" d="M16.25 24.25H47.75V43.75H16.25V24.25ZM17.75 29.3252V42.25H46.25V29.324L33.9284 36.717C32.7408 37.4296 31.2572 37.4296 30.0696 36.717L17.75 29.3252ZM17.75 27.576L30.8414 35.4308C31.5539 35.8583 32.4441 35.8583 33.1566 35.4308L46.25 27.5748V25.75H17.75V27.576Z" fill="#F23D4F" />
  </svg>
);


const ExErrorMP: FunctionComponent = () => (
  <svg className="error-svg" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.5" y="1.5" width="61" height="61" rx="30.5" fill="white" />
    <rect x="1.5" y="1.5" width="61" height="61" rx="30.5" stroke="#F23D4F" strokeWidth="3" />
    <rect x="40" y="40" width="24" height="24" rx="12" fill="#F23D4F" />
    <path d="M53.455 45.8181H50.5459L50.9095 53.8181H53.0914L53.455 45.8181Z" fill="white" />
    <path d="M52.0004 55.2727C52.8038 55.2727 53.455 55.9239 53.455 56.7272C53.455 57.5305 52.8038 58.1818 52.0004 58.1818C51.1971 58.1818 50.5459 57.5305 50.5459 56.7272C50.5459 55.9239 51.1971 55.2727 52.0004 55.2727Z" fill="white" />
    <path d="M21.9385 23.0001L30.9385 32.0001L21.9385 41.0001L22.9991 42.0608L31.9991 33.0608L40.9991 42.0608L42.0598 41.0001L33.0598 32.0001L42.0598 23.0001L40.9991 21.9395L31.9991 30.9395L22.9991 21.9395L21.9385 23.0001Z" fill="#F23D4F" />
  </svg>
);

export const EmailErrorSVG: FunctionComponent = () => (<EmailErrorMP />);
export const ExErrorSVG: FunctionComponent = () => (<ExErrorMP />);
